import "../Custom.css"
import ServicesPage from "./ServicesPage"
import {
  CONSULTANTS_SERVICE_PAGE_IMAGE_FOUR,
  CONSULTANTS_SERVICE_PAGE_IMAGE_ONE,
  CONSULTANTS_SERVICE_PAGE_IMAGE_THREE,
  CONSULTANTS_SERVICE_PAGE_IMAGE_TWO,
} from "../utils/constants"

const BusinessConsultant = () => {
  const leftColumnData = [
    {
      title: "Entry Strategy",
      desc: "Explore new markets with confidence. We conduct in-depth market research and craft bespoke entry strategies for your successful expansion into international markets.",
      imgPath: CONSULTANTS_SERVICE_PAGE_IMAGE_ONE,
    },
    {
      title: "Compliance Assistance",
      desc: "Navigate foreign regulations effortlessly. Our expert guidance ensures your business complies with legal, financial, and operational requirements in overseas territories.",
      imgPath: CONSULTANTS_SERVICE_PAGE_IMAGE_TWO,
    },
  ]

  const rightColumnData = [
    {
      title: "Cultural Adaptation",
      desc: "Connect with local audiences seamlessly. We help you understand and adapt to diverse cultures, ensuring your products/services resonate effectively.",
      imgPath: CONSULTANTS_SERVICE_PAGE_IMAGE_THREE,
    },
    {
      title: "Ongoing Support",
      desc: "Stay supported throughout your international journey. We provide continuous guidance and management support as you establish and grow your presence in global markets.",
      imgPath: CONSULTANTS_SERVICE_PAGE_IMAGE_FOUR,
    },
  ]

  return (
    <>
      <ServicesPage prop={{ leftColumnData, rightColumnData }} />
    </>
  )
}

export default BusinessConsultant
